import { render } from "./JobDotNetDeveloper.vue?vue&type=template&id=5976e406&scoped=true"
import script from "./JobDotNetDeveloper.vue?vue&type=script&lang=js"
export * from "./JobDotNetDeveloper.vue?vue&type=script&lang=js"

import "./JobDotNetDeveloper.vue?vue&type=style&index=0&id=5976e406&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5976e406"]])

export default __exports__